import { actions } from 'Data/ReduxViewModels/PageSections';
import { HiChevronDown, HiChevronUp } from 'Lib/Icons';
import { toTitleCase } from 'Lib/String';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import './PageSection.scss';

interface IPageSectionProps {
  heading?: string;
  id?: string;
  visible?: boolean;
}

let idCounter = 0;

/**
 * A component for top-level page sections.
 */
const PageSectionBase: React.FC<React.PropsWithChildren<IPageSectionProps>> = ({
  children,
  heading,
  id: idProp,
  visible = true,
}) => {
  if (heading) {
    heading = toTitleCase(heading);
  }

  const [id] = useState(idProp ?? `page-section-${idCounter++}`);
  const collapsed = useSelector((state) => state.pageSections.collapsed[id] ?? false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (heading) {
      dispatch(actions.addPageSectionId(id));
      return () => {
        dispatch(actions.deletePageSectionId(id));
      };
    }
  }, [dispatch, id, heading]);

  const handleClick = () => dispatch(actions.setCollapsed({ id, collapsed: !collapsed }));

  return !visible ? null : (
    <section className={classNames('PageSection', { 'PageSection-collapsed': collapsed })} id={id}>
      {heading && (
        <h1 className="PageSection-Heading">
          <button className="PageSection-HeadingButton" onClick={handleClick}>
            {heading}
            {collapsed ? <HiChevronDown /> : <HiChevronUp />}
          </button>
        </h1>
      )}
      <div className="PageSection-Content">{children}</div>
    </section>
  );
};

const PageSection = withInjectedProps(PageSectionBase);

export { PageSection };
export default PageSection;
